import { useMemo } from 'react';

import { useLiveQuery } from 'dexie-react-hooks';

import { getChannelDisplayName } from '../lib/channels';
import db, { DEXIE_IS_LOADING } from '../lib/db';

import { useRouteWorkspace } from '../contexts/RouteWorkspaceContext';

export function useThreadListChannels() {
  const { workspaceId, mainChannelId } = useRouteWorkspace();
  const raw = useLiveQuery(
    async () => {
      // get the main channel and any open_breakout channels for this workspace
      const allChannels = await db.channels
        .where('[workspace_id+kind]')
        .anyOf([
          [workspaceId, 'public'],
          [workspaceId, 'open_breakout'],
        ])
        .toArray();

      // if there are no open_breakout channels, return an empty array
      if (!allChannels.some((c) => c.kind === 'open_breakout')) return [];

      // sort the channels by display name, with the main channel first
      let mainChannel = null;
      const others = [];

      for (const c of allChannels) {
        if (mainChannelId && String(c.id) === String(mainChannelId)) {
          mainChannel = c;
        } else {
          others.push(c);
        }
      }

      // sort the other channels alphabetically by display name
      const namesById = new Map(others.map((c) => [c.id, getChannelDisplayName(c).toLowerCase()]));
      others.sort((a, b) => namesById.get(a.id).localeCompare(namesById.get(b.id)));

      return [mainChannel, ...others];
    },
    [workspaceId, mainChannelId],
    DEXIE_IS_LOADING,
  );

  return useMemo(() => (raw === DEXIE_IS_LOADING || raw == null ? [] : raw), [raw]);
}
